import React, { Component } from 'react';
// import Link from 'gatsby-link';
// import { inject, observer } from 'mobx-react';
// import styled from 'styled-components';
// import ReactMapboxGl, { Marker, Feature } from "react-mapbox-gl";
// import 'mapbox-gl/dist/mapbox-gl.css';

import { Row, Column } from '../../global/grid/grid';
import Image from '../../global/media/Image'

// import StorePin from '../../../static/svgs/pothole-pin.svg';

import { Title, MapEdge, PotholeMapWrapper } from './styled-components';

let MapComponent = null;


/*
@inject("store")
@observer class PotholeMap extends Component {
  constructor(props) {
    super(props);
    this.bounds = null;
    this.state = {
      bounds: null,
      markers: null,
      center: [-98.579439, 39.828409],
      zoom: [3],
    }
    this.onStyleLoad = this.onStyleLoad.bind(this);
    this.map = null;
    this.createMarkers = this.createMarkers.bind(this);
  }
  componentWillMount() {
    if (typeof window !== `undefined`) {
      MapComponent = ReactMapboxGl({
        accessToken: "pk.eyJ1IjoieW8tZG9taW5vcy1kZXZob3BzIiwiYSI6ImNqaDZzNnh4ejAwZnUyeHBjMDlkOTcxenoifQ.6Y76_f8tj1x6JcxeqJP8oA"
      });
    }
  }
  componentDidMount() {
    const { data } = this.props;
    this.createMarkers(data.potholes);
  }
  shouldComponentUpdate() {
    return true
  }
  createMarkers(markersData) {
    // console.log(markersData);
    let lats = []; let lngs = [];
    const markers = markersData.map( (marker, index) => {
      const latitude = marker[0];
      const longitude = marker[1];
      lats.push(latitude);
      lngs.push(longitude);
      return (
        <Marker
          key={index}
          coordinates={[longitude, latitude]}
          anchor="bottom"
          style={{height:'52px', width:'43px', pointerEvents: 'none', zIndex: '1'}}
        >
          <StorePin />
        </Marker>
      )
    });
    const minLats = Math.min(...lats);
    const maxLats = Math.max(...lats);
    const minLongs = Math.min(...lngs);
    const maxLongs = Math.max(...lngs);
    const bounds = [[minLongs, minLats],[maxLongs, maxLats]];
    setTimeout( () => {
      this.setState({
        bounds: bounds,
        markers: markers
      });
    }, 500);
  }
  onStyleLoad(e) {
    if(this.map) {
      this.map.scrollZoom.disable();
      this.map.doubleClickZoom.disable();
    }
  }
  render() {
      const { data, store } = this.props;
        return (
        <PotholeMapWrapper>
          <Row margins={true}>
              <Column cw={12} style={{textAlign: 'center'}}>
                  <Title>{data.title}</Title>
              </Column>
              <Column cw={10} offset={1} style={{position: 'relative'}}>
                  <div style={{paddingTop: '56.25%', width: '100%'}}></div>
                  <div style={{
                      position: 'absolute',
                      top: 0,
                      bottom: 0,
                      right: 0,
                      left: 0
                  }}>
                  { this.state.bounds &&
                      <MapComponent
                          // style="mapbox://styles/mapbox/streets-v9"
                          style="mapbox://styles/yo-dominos-devhops/cjibzx6bj00bz2smc03qtv6c5"
                          containerStyle={{
                          height: '100%',
                          width: '100%'
                          }}
                          onStyleLoad={ (el) => {this.map = el; this.onStyleLoad();} }
                          fitBounds={this.state.bounds}
                          fitBoundsOptions={{padding: store.isMobile ? 35 : 80}}
                          scrollZoom={false}
                          doubleClickZoom={false}
                      >
                          { this.state.markers }
                      </MapComponent>
                  }
                  </div>
              </Column>
          </Row>
        </PotholeMapWrapper>
        )
  }
}
*/
/**
 * To avoid mapbox, use a static asset instead.
 */
class PotholeMap extends Component {
  render() {
    const { data, imageDictionary } = this.props;
    return (
      <PotholeMapWrapper>
        <Row margins={true}>
            <Column cw={12} style={{textAlign: 'center'}}>
                <Title>{data.title}</Title>
            </Column>
            <Column cw={10} offset={1} style={{position: 'relative'}}>
                <div style={{paddingTop: '56.25%', width: '100%'}}></div>
                <div style={{
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0
                }}>
                  <Image aspectHeight={9} aspectWidth={16} sizes={imageDictionary[data.asset].sizes} />
                </div>
            </Column>
        </Row>
      </PotholeMapWrapper>
    )
  }
}

export default PotholeMap;


// WEBPACK FOOTER //
// ./src/components/modules/PotholeMap/PotholeMap.js